export default {"src":"/_next/static/media/azure.9c9dc7f7.svg","height":244,"width":256,"blurWidth":0,"blurHeight":0};